module.exports = __webpack_public_path__ + "03_long_brown.4fe0fd4f.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/mom/layer5/03_long_brown.png
// module id = 6u19
// module chunks = 0